import './App.css';
import { comparePFCLS, PFCLS, reglesPFCLS } from './Rules';
import React from 'react';


const randomEnumValue = (enumeration: any) => {
  const values = Object.keys(enumeration);
  const enumKey = values[Math.floor(Math.random() * values.length)];
  return enumeration[enumKey];
}
let scoreP = 0
let scoreC = 0;
const divScoreP = document.createElement("div");
const divScoreC = document.createElement("div");
const divRule =  document.createElement("div");

function game(playerChoice: PFCLS) {
  let computerChoice: PFCLS = randomEnumValue(PFCLS);
  const divGame = document.getElementById("game");
  if (divGame != null) {
    divGame.appendChild(divRule)
  }
  if (comparePFCLS(playerChoice, computerChoice) < 0) {
    scoreC++;
    divRule.innerHTML = "You loose because " +  reglesPFCLS(playerChoice,computerChoice)

  }
  else if (comparePFCLS(playerChoice, computerChoice) > 0) {
    scoreP++;
    divRule.innerHTML =  "You win because " +  reglesPFCLS(playerChoice,computerChoice)
  }
  else {
    scoreC++;
    scoreP++;
    divRule.innerHTML = reglesPFCLS(playerChoice,computerChoice);
  }
  const d1 = document.getElementById("scC")
  const d2 = document.getElementById("scP")
  if (d1!=null && d2!=null){
    d1.innerHTML = ""+scoreC;
    d2.innerHTML = ""+scoreP;
  }
}

export function App1() {
  return (
    <div className="App">
      <header className="App-header">
      <div> <h1>Welcome to Rock Paper Scissors Lizard Spock</h1></div>
        <div id='game'>
          <img src={require('../src/assets/img/Scissors.jpg')} onClick={() => game(PFCLS.Scissors)} alt='Scissors' />
          <img src={require('../src/assets/img/Rock.jpg')} onClick={() => game(PFCLS.Rock)} alt='Rock' />
          <img src={require('../src/assets/img/Paper.jpg')} onClick={() => game(PFCLS.Paper)} alt='Paper' />
          <img src={require('../src/assets/img/Lizard.jpg')} onClick={() => game(PFCLS.Lizard)} alt='Lizard' />
          <img src={require('../src/assets/img/Spock.jpg')} onClick={() => game(PFCLS.Spock)} alt='Spock' />
        </div>
      </header>
    </div>
  );
}

export default App1;
